import axios from "axios";

export const notificationsAPI = axios.create({
  baseURL: "/api/notifications/",
});
